// extracted by mini-css-extract-plugin
export default {"sale-soon-wrapper":"YdMC5t","promo-sale-soon-wrapper":"Izaqeo","promo-sale-soon-wrapper--s":"MPH4kj","button-wrapper":"_33T2OH"};